import { selectedPropertyHasPermission } from 'App/Map/PanelDetails/_utils/selectedPropertyHasPermission'
import { DEVICE_GROUPS_PERMISSIONS } from '../Map/_utils/getNodeDeviceTypes'

export const checkDeviceGroupPermission = (deviceGroupName: string) =>
  selectedPropertyHasPermission({ permission: DEVICE_GROUPS_PERMISSIONS[deviceGroupName] })
